import { formatMovieDisplayTitleFromId } from '@watchlist/shared';

/** Backfilled / legacy activities use placeholder titles with no poster. */
export function isLikelyPlaceholderCrewTitle(
  title: string | undefined,
  movieId: string | undefined
): boolean {
  if (!movieId) return false;
  if (!title) return true;
  const t = title.trim();
  if (t === 'Film') return true;
  if (t === `Movie ${movieId}`) return true;
  if (t === formatMovieDisplayTitleFromId(movieId)) return true;
  return /^Movie\s+(#\d+|tmdb_\d+|\d+)$/i.test(t);
}

export function hasUsableCrewPoster(p?: string | null): boolean {
  return !!(p && p !== 'N/A' && String(p).trim());
}
